/** ¿Estamos en un ancho de teléfono? Lo usan los gráficos (para elegir su geometría) y la tabla
 *  (para apilarse en vez de pedir scroll lateral), así que vive aquí y no dentro de `graficos/`.
 */
import { useEffect, useState } from "react";

/* El ancho del `viewBox` de un gráfico en móvil. Medido el 2026-09-09 en un iPhone (375 px): la
   tarjeta deja 257 px útiles, así que un viewBox de 620 se renderizaba a escala 0,48 y el texto
   declarado a 11 px salía a **5,3 px efectivos** — se ve el gráfico y no se lee nada. Con 360 la
   escala queda en ~0,71 y con las tipografías subidas a 13 px el texto sale a ~9 px reales, que
   es el mínimo legible. */
export const ANCHO_MOVIL = 360;

const CONSULTA = "(max-width: 640px)";

/** Con `matchMedia` y no midiendo el contenedor: medir crea una carrera —el hijo necesita el
 *  ancho para calcular su alto, y el alto para pintarse— y lo que de verdad discrimina aquí es
 *  el tipo de pantalla, no unos píxeles. */
export function useEsMovil(): boolean {
  const [movil, setMovil] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(CONSULTA).matches
      : false);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(CONSULTA);
    const alCambiar = (e: MediaQueryListEvent) => setMovil(e.matches);
    setMovil(mq.matches);
    mq.addEventListener("change", alCambiar);
    return () => mq.removeEventListener("change", alCambiar);
  }, []);
  return movil;
}
